<template>
    <div>
        <v-breadcrumbs
            :items=breadcrumbs
            class="pl-md-4 pl-3 "
        >
            <template v-slot:divider>
                <v-icon color='#50c996'>mdi-chevron-right</v-icon>
            </template>
            <template v-slot:item="{ item }">
                <v-breadcrumbs-item :href="item.url">
                <span class='gray--text font-weight-medium '>{{ item.name }}</span>
                </v-breadcrumbs-item>
                
            </template>
        </v-breadcrumbs>
        <div class='text-right primary--text atras' style='cursor:pointer' @click='$router.go(-1)'>
            <v-icon class='blue--text'>mdi-chevron-left</v-icon> Atrás
        </div>
    </div>
</template>

<script>
export default {
    name:'BreadCrumbsComponent',
    data:()=>({
        breadCrumbs:[]
    }),
    props:{
        breadcrumbs:{
            type: Array,
            default:()=> []
        }
    },
    created(){

        
        //console.log(this.items)
        //this.breadCrumbs.push(this.items)
        /* this.breadCrumbs= this.$route.path.split('/')
        this.breadCrumbs[0]='/' */
        let paths= this.$route.path.split('/')

        /* for(let i=0; i < paths.length;i++){
            console.log( paths[i])
            this.breadCrumbs.push({
                name: paths[i] == '' ? 'Inicio' : paths[i].split('-').join(' '),
                href: paths[i] == '' ? '/' : paths[i]
            })
        } */
       
        
       
    }
}
</script>

<style>
    

     @media(min-width:710px){
        .atras{
            position: relative;
            top: -40px;
            right: 15px;
        }

     }

    
</style>